import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as toastr from 'toastr';
import { API_STORAGE_REMOTE, API_URL_API_REMOTE, API_URL_REMOTE } from '../env';
import { Router } from '@angular/router';
import { io, Socket } from 'socket.io-client';

interface ConnectionI {
  state : string
}

@Injectable({
  providedIn: 'root',
})
export class DatabaseConnection {
  connection = new BehaviorSubject<boolean>(true)

  remoteApiConnection = new BehaviorSubject<string>(API_URL_API_REMOTE)
  remoteConnection = new BehaviorSubject<string>(API_URL_REMOTE)
  storageConnection = new BehaviorSubject<string>(API_STORAGE_REMOTE)

  cpt : boolean = true

  private socket!: Socket;

  toastr = toastr
  constructor(
    private http : HttpClient,
    private router : Router
  ){
    //this.getConnectionState()
    //this.socket = io(SOCKET_URL, {auth : {key:SOCKET_KEY}});
  }


 initConnection() : Promise<boolean>{
    return new Promise<boolean>((resolve, rejet) =>{
      this.http.get<any>(API_URL_API_REMOTE + 'getConnectionState').subscribe({
        next : (res : ConnectionI) => {
            this.cpt = true
            if(!this.connection.value)
              this.connection.next(true)
            /*this.remoteApiConnection.next(API_URL_API_REMOTE)
            this.remoteConnection.next(API_URL_REMOTE)
            this.storageConnection.next(API_STORAGE_REMOTE)*/
            resolve(true)
        },
        error : (err) =>{
            this.cpt = false
            if(this.connection.value)
            this.connection.next(false)

            /*this.remoteApiConnection.next(API_URL_API)
            this.remoteConnection.next(API_URL)
            this.storageConnection.next(NATIVE_API_STORAGE)*/
            resolve(false)
        }
      })
    })
 }


 //serveur socket
  /*initConnection() : Promise<boolean>{
    return new Promise<boolean>((resolve, rejet) =>{
       // Erreur de connexion (ex: serveur éteint au démarrage)
      this.socket.on('connect_error', (error) => {
        this.localMode()
        resolve(false)
        console.error('Erreur de connexion Socket.IO :', error.message);
      });

      // Déconnexion imprévue (ex: le serveur s'éteint en plein milieu)
      this.socket.on('disconnect', (reason) => {
        this.localMode()
        resolve(false)
        console.error('Erreur de connexion Socket.IO :', reason);
      });

      this.socket.on('sygma_connection', (data : {connection : Boolean}) => {
        if(data.connection){
            this.cpt = true
            if(!this.connection.value)
              this.connection.next(true)
            this.remoteApiConnection.next(API_URL_API_REMOTE)
            this.remoteConnection.next(API_URL_REMOTE)
            this.storageConnection.next(API_STORAGE_REMOTE)
            resolve(true)
        }else{
            this.localMode()
            resolve(false)
        }
      });
    })
  }*/



  getConnectionState() {
    const interval = setInterval(() => this.initConnection(), 10000);
  }

  /*localMode(){
    this.cpt = false
    if(this.connection.value)
      this.connection.next(false)
    this.remoteApiConnection.next(API_URL_API)
    this.remoteConnection.next(API_URL)
    this.storageConnection.next(NATIVE_API_STORAGE)
  }*/

}
